<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'pageHeader.home' | translate}}</a></li>
  <li class="active">{{'pageHeader.UsersManagements' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.UsersManagements' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'users.usersManagementsSearch' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-3">
          <input type="text" (input)="onSearchChanged($event)" [(ngModel)]="searchText" class="form-control" placeholder="{{'app.Search' | translate}}">
        </div>
        <div class="col-sm-3">
          <span class="ui-fluid">
            <p-dropdown [options]="displayFilter"
                        name="displayFil" #displayFil="ngModel"
                        styleClass="wid100"
                        placeholder="Filter"
                        [(ngModel)]="display"
                        [virtualScroll]="true" itemSize="3"
                        optionLabel="label"
                        (onChange)="onChangeActiveFilter()"></p-dropdown>

          </span>
        </div>
        <div class="col-sm-3 margin-top-10 cursor-pointer">
          <span class="ui-fluid">Count : {{rows.length}}</span>
        </div>
        <div class="col-sm-3 margin-top-10 left-10 cursor-pointer" (click)="newUser()" *ngIf="canManageUsers">
          <span class="margin-right-7 create-new-span">Create New User</span>
          <i class="fa fa-plus-circle"></i>
        </div>
        <div class="col-sm-3 margin-top-10 left-10 cursor-pointer" (click)="showEquipmentUpload()" *ngIf="canManageUsers">
          <span class="margin-right-7 create-new-span">{{'users.equipmentBulkUpload' | translate}}</span>
          <i class="fa fa-upload"></i>
        </div>
        <div class="col-sm-3 margin-top-10 left-10 cursor-pointer" (click)="forceLogoutAll()" *ngIf="canControlAuthentication">
          <span class="margin-right-7 create-new-span">Force Logout Everyone</span>
          <i class="fa fa-power-off"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-user-editor *ngIf="addNew" (closeEvent)="closeAdding($event)" (showProvision)="showProvisionModal($event)" [userId]="selectedUserId"></crm-user-editor>
<crm-user-jobs *ngIf="jobMode" (closeEvent)="closeAdding($event)" [userId]="selectedUserId"></crm-user-jobs>


<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'users.usersManagementsSearchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-table #dt styleClass="um-grid" [value]="rows" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize" [resizableColumns]="true">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn style="text-align:center" class="table-edit">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canManageUsers">{{'app.edit' | translate}}</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canManageUsers">{{'app.delete' | translate}}</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canControlAuthentication">{{'app.resetPassword' | translate}}</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canControlAuthentication">{{'app.forceLogout' | translate}}</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canManageUsers">{{'users.jobs' | translate}}</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canViewWorkingDays">Working Days</th>
                <th style="text-align:center" class="table-edit um-action" *ngIf="canManageUsers" title="Managers: where their business trips start (From of a matrix expense)">Centre Bricks</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
              <tr *ngIf="rows.length>0 && displayMode===2">
                <td class="ui-resizable-column">
                  <span [class.locked-out]="user.isLockedOut" [class.user-disabled]="!user.isEnabled">
                    <i *ngIf="user.isLockedOut" class="fa fa-exclamation-triangle"> </i>
                    <i *ngIf="!user.isEnabled" class="fa fa-exclamation"> </i>

                    {{user.userName}}
                  </span>
                </td>
                <td class="ui-resizable-column">{{user.fullName}}</td>
                <td class="ui-resizable-column">{{user.hrCode}}</td>
                <td class="ui-resizable-column">{{user.businessUnitName}}</td>
                <td class="ui-resizable-column">{{user.jobName}}</td>
                <td class="ui-resizable-column">{{user.email}}</td>
                <td class="ui-resizable-column">{{user.phoneNumber}}</td>
                <td class="ui-resizable-column um-roles">
                  <span class="user-role badge" *ngIf="user.roles?.length">{{firstRole(user)}}</span>
                  <a href="javascript:;" class="um-more" *ngIf="user.roles?.length > 1" (click)="showRoles(user)" [title]="user.roleNames">+{{user.roles.length - 1}}</a>
                </td>
                <td class="ui-resizable-column">{{user.hiringDate | date}}</td>
                <td class="ui-resizable-column">{{user.creationDate | date}}</td>
                <td class="ui-resizable-column">{{user.lastWebLoginDate | date}}</td>
                <td class="ui-resizable-column">{{user.lastMobileLoginDate | date}}</td>
                <td class="ui-resizable-column">{{user.carLicenseNo}}</td>
                <td class="ui-resizable-column um-center">
                  <a href="javascript:;" class="um-count" *ngIf="user.equipmentCount" (click)="showEquipment(user)" [title]="'users.showEquipment' | translate">{{user.equipmentCount}}</a>
                  <span class="text-muted" *ngIf="!user.equipmentCount">0</span>
                </td>

                <td *ngIf="canManageUsers">
                  <a class="" href="javascript:;" (click)="editUser(user)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="canManageUsers"><a href="javascript:;" (click)="deleteUser(user)"><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>

                <td *ngIf="canControlAuthentication">
                  <a class="" href="javascript:;" (click)="resetPassword(user.id)"><i class="fa fa-refresh fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="canControlAuthentication">
                  <a class="" href="javascript:;" (click)="forceLogoutUser(user.id)" title="Force logout this user"><i class="fa fa-sign-out fa-lg font-size-20"></i></a>
                </td>
                <td *ngIf="canManageUsers"><a href="javascript:;" (click)="userJobs(user)"><i class="fa fa-briefcase  fa-lg font-size-20"></i></a></td>
                <td *ngIf="canViewWorkingDays"><a href="javascript:;" (click)="userWorkingDays(user)" title="Working days of this user"><i class="fa fa-calendar  fa-lg font-size-20"></i></a></td>
                <td *ngIf="canManageUsers" class="um-centre">
                  <a href="javascript:;" *ngIf="isManager(user)" (click)="userCentreBricks(user)"
                     [title]="centreCount(user) ? centreCount(user) + ' centre brick(s)' : 'No centre bricks: the centres of the territories under this user are used'">
                    <i class="fa fa-map-marker fa-lg font-size-20"></i>
                    <span class="um-centre-count" [class.um-centre-none]="!centreCount(user)">{{centreCount(user)}}</span>
                  </a>
                </td>
              </tr>
              <tr *ngIf="rows.length===0 && displayMode===2">
                <td colspan="6">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="6">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>

                  </div>

                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-8">
  </div>
  <div class="col-sm-2 cursor-pointer left-15">
  </div>
  <div class="col-sm-2 cursor-pointer left-7" (click)="downloadCSV()">
    <span class="margin-right-7 edit-profile-span">{{'app.ExportSheet' | translate}}</span>
    <i class="fa fa-download" aria-hidden="true"></i>
  </div>
</div>

<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteUserHelper()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modal-sizes-1" bsModal #provisionModal="bs-modal" (onHidden)="onProvisionModalHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog  modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'users.uploadUsersResult' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="provisionModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <crm-provision-users #provisionUsers></crm-provision-users>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #equipmentUploadModal="bs-modal" (onHidden)="onEquipmentUploadHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'users.equipmentBulkUpload' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="equipmentUploadModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="panel-body clearfix eu">
        <p class="text-muted">{{'users.equipmentBulkHint' | translate}}</p>
        <div class="eu-step">
          <div class="eu-num">1</div>
          <div class="eu-body">
            <strong>{{'users.equipmentBulkDownload' | translate}}</strong>
            <div class="text-muted eu-small">{{'users.equipmentBulkDownloadHint' | translate}}</div>
          </div>
          <button type="button" class="btn eu-btn" (click)="downloadEquipmentTemplate()"><i class="fa fa-download"></i> {{'app.downloadTemplate' | translate}}</button>
        </div>
        <div class="eu-step">
          <div class="eu-num">2</div>
          <div class="eu-body">
            <strong>{{'users.equipmentBulkUploadStep' | translate}}</strong>
            <div class="text-muted eu-small">{{'users.equipmentBulkUploadHint' | translate}}</div>
          </div>
          <input #equipmentFile type="file" accept=".csv" class="hidden" (change)="uploadEquipment(equipmentFile)" />
          <button type="button" class="btn eu-btn" (click)="equipmentFile.click()" [disabled]="equipmentUploading">
            <i class="fa" [ngClass]="equipmentUploading ? 'fa-spinner fa-spin' : 'fa-upload'"></i> {{'app.uploadTemplate' | translate}}
          </button>
        </div>
        <div class="eu-result" *ngIf="equipmentResult" [class.eu-warn]="equipmentResult.errors?.length">
          <div><i class="fa fa-check-circle"></i> {{'users.equipmentBulkResult' | translate:{ users: equipmentResult.updatedUsers, equipment: equipmentResult.equipmentCount } }}</div>
          <ng-container *ngIf="equipmentResult.errors?.length">
            <div class="eu-errors-title">
              <i class="fa fa-exclamation-triangle"></i> {{'users.equipmentBulkErrors' | translate:{ count: equipmentResult.errors.length } }}
              <a href="javascript:;" (click)="downloadEquipmentErrors()">{{'users.equipmentBulkDownloadErrors' | translate}}</a>
            </div>
            <ul class="eu-errors">
              <li *ngFor="let error of equipmentResult.errors | slice:0:50">{{error}}</li>
            </ul>
          </ng-container>
        </div>
        <div class="eu-result eu-error" *ngIf="equipmentUploadError"><i class="fa fa-times-circle"></i> {{equipmentUploadError}}</div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #rolesModal="bs-modal" (onHidden)="rolesUser = null" tabindex="-1">
  <div class="modal-dialog">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'users.roles' | translate}} - {{rolesUser?.fullName || rolesUser?.userName}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="rolesModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="panel-body clearfix">
        <ul class="um-role-list" *ngIf="rolesUser">
          <li *ngFor="let role of rolesUser.roles"><span class="user-role badge">{{role.name}}</span> <span class="text-muted">{{role.description}}</span></li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #equipmentModal="bs-modal" (onHidden)="equipmentUser = null" tabindex="-1">
  <div class="modal-dialog">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'users.equipment' | translate}} - {{equipmentUser?.fullName || equipmentUser?.userName}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="equipmentModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="panel-body clearfix">
        <table class="table table-bordered" *ngIf="equipmentUser?.equipments?.length">
          <thead>
            <tr>
              <th>#</th>
              <th>{{'users.equipmentType' | translate}}</th>
              <th>{{'users.serialNumber' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of equipmentUser.equipments; let i = index">
              <td>{{i + 1}}</td>
              <td>{{item.equipmentTypeName}}</td>
              <td>{{item.serialNumber}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #centreBricksModal="bs-modal" (onHidden)="centreBricksUser = null" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">Centre Bricks - {{centreBricksUser?.fullName || centreBricksUser?.userName}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="centreBricksModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="panel-body clearfix">
        <user-centre-bricks *ngIf="centreBricksUser" [userId]="+centreBricksUser.id" [canManage]="canManageUsers"
                            (changed)="centreCounts[+centreBricksUser.id] = $event"></user-centre-bricks>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #workingDaysModal="bs-modal" (onHidden)="workingDaysUser = null" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">Working Days - {{workingDaysUser?.fullName || workingDaysUser?.userName}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="workingDaysModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="panel-body clearfix">
        <working-days-editor *ngIf="workingDaysUser" [userId]="+workingDaysUser.id" [canManage]="canEditWorkingDaysUser"></working-days-editor>
        <p class="text-muted" *ngIf="workingDaysUser && canManageWorkingDays && !canEditWorkingDaysUser">You cannot change your own working days.</p>
      </div>
    </div>
  </div>
</div>
